import { useSyncExternalStore } from 'use-sync-external-store/shim';

const __DEV__ = process.env.NODE_ENV !== 'production';
const __DEV_ERR__ = (msg) => {
    if (__DEV__) {
        throw new Error(msg);
    }
};
let isInMethod = false;
let run = (fn) => {
    fn();
};
const resso = (data) => {
    if (__DEV__ && Object.prototype.toString.call(data) !== '[object Object]') {
        throw new Error('object required');
    }
    const state = {};
    const methods = {};
    Object.keys(data).forEach((key) => {
        const initVal = data[key];
        if (initVal instanceof Function) {
            methods[key] = (...args) => {
                isInMethod = true;
                const res = initVal(...args);
                isInMethod = false;
                return res;
            };
            return;
        }
        const listeners = new Set();
        state[key] = {
            subscribe: (listener) => {
                listeners.add(listener);
                return () => listeners.delete(listener);
            },
            getSnapshot: () => data[key],
            setSnapshot: (val) => {
                if (val !== data[key]) {
                    data[key] = val;
                    run(() => listeners.forEach((listener) => listener()));
                }
            },
            useSnapshot: () => {
                return useSyncExternalStore(state[key].subscribe, state[key].getSnapshot, state[key].getSnapshot);
            },
        };
    });
    const setState = (key, val) => {
        if (key in data) {
            if (key in state) {
                const newVal = val instanceof Function ? val(data[key]) : val;
                state[key].setSnapshot(newVal);
            }
            else {
                __DEV_ERR__(`\`${key}\` is a method, can not update`);
            }
        }
        else {
            __DEV_ERR__(`\`${key}\` is not initialized in store`);
        }
    };
    return new Proxy((() => undefined), {
        get: (_, key) => {
            if (key in methods) {
                return methods[key];
            }
            if (isInMethod) {
                return data[key];
            }
            try {
                return state[key].useSnapshot();
            }
            catch (err) {
                return data[key];
            }
        },
        set: (_, key, val) => {
            setState(key, val);
            return true;
        },
        apply: (_, __, [key, updater]) => {
            if (typeof updater === 'function') {
                setState(key, updater);
            }
            else {
                __DEV_ERR__(`updater for \`${key}\` should be a function`);
            }
        },
    });
};
resso.config = ({ batch }) => {
    run = batch;
};

export { resso as default };
